/**
 * Base model fields returned by the Mevi API on all resources.
 * Mirrors the Go API base model (ID, timestamps, audit fields, metadata).
 */

const BASE_FIELDS = [
  "id",
  "createdAt",
  "updatedAt",
  "deletedAt",
  "instanceVersion",
  "createdBy",
  "updatedBy",
  "deletedBy",
  "createdByUserProfile",
  "updatedByUserProfile",
  "metadata",
];

/**
 * Extracts base model properties from an API response object.
 * @param {Object} json - Raw API response JSON
 * @returns {Object} Base model fields only
 */
export const parseBaseModel = (json) => {
  if (!json) return {};

  return {
    id: json.id || null,
    createdAt: json.createdAt || null,
    updatedAt: json.updatedAt || null,
    deletedAt: json.deletedAt || null,
    instanceVersion: json.instanceVersion ?? 0,
    createdBy: json.createdBy || null,
    updatedBy: json.updatedBy || null,
    deletedBy: json.deletedBy || null,
    createdByUserProfile: json.createdByUserProfile || null,
    updatedByUserProfile: json.updatedByUserProfile || null,
    metadata: json.metadata || {},
  };
};

/**
 * Strips base model fields from an object, returning only domain-specific data.
 * @param {Object} json - Object potentially containing base model fields
 * @returns {Object} Object without base model fields
 */
export const stripBaseFields = (json) => {
  if (!json) return {};

  const result = { ...json };
  BASE_FIELDS.forEach((field) => delete result[field]);
  return result;
};

export default { parseBaseModel, stripBaseFields, BASE_FIELDS };
